/**
 * SHARED LEGACY FILE
 *
 * These account utilities are used by multiple apps split from LearningCenterUI.
 * They do not belong to any single app — each app that needs them
 * imports this shared copy.
 *
 * The .legacy suffix exists to preserve git history transfer.
 */

import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { GET_USER_INFO, GET_ACCOUNTS, GET_CROSS_ACCOUNTS, GET_GATES_AND_SCOPES } from 'academy-common-lib/features/accounts/accountsQueries';
export { useUserInfo, useAccounts, useGatesAndScopes, useGateOverrideStore, useGateOverride, useHasGate, useScopeOverrideStore, useScopeOverride, useHasScope, useScopes, useUsersForAccount, useHasPortalScope, GET_USER_INFO, GET_ACCOUNTS, GET_CROSS_ACCOUNTS, GET_GATES_AND_SCOPES } from 'academy-common-lib/features/accounts/accountsQueries';
export const getUserInfo = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_USER_INFO
  });
};
export const getAccounts = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_ACCOUNTS
  });
};
export const getCrossAccounts = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_CROSS_ACCOUNTS
  });
};
export const getGatesAndScopes = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_GATES_AND_SCOPES
  });
};